module.exports = __webpack_public_path__ + "static/media/pdf.4960fba9.png";